import { createContext, useContext } from 'react';
import type { KiCodeOpenArgs, KiCodeTarget } from './profiles';

export interface KiCodeApi {
  open: (args: KiCodeOpenArgs) => void;
  close: () => void;
  session: KiCodeTarget | null;
}

const noop = () => {};

export const KiCodeContext = createContext<KiCodeApi>({
  open: noop,
  close: noop,
  session: null,
});

export const useKiCode = (): KiCodeApi => useContext(KiCodeContext);
